import { gql } from "@apollo/client";

export const CHECK_USER_AUTHENTICATED = gql`
  query getUserByToken {
    getUserByToken {
      accountingFirms
      companies
      isActive
      userCategory {
        id
        name
        slug
      }
      isSuperuser
      id
      firstName
      lastName
      email
      permissions
      isNewraiUser
      language
    }
  }
`;

export const LIST_USERS_OPS = gql`
  query listOPS($search: String, $companyId: String, $offset: Int) {
    listUsersPaginated(
      searchContains: $search
      companies_Contains: $companyId
      permission_In: ["neossi-api.can-validate-book-entries"]
      isNewraiUser: true
      isActive: true
    ) {
      results(limit: 10, offset: $offset) {
        id
        firstName
        lastName
        email
      }
    }
  }
`;

export const LIST_USERS_NEOTRESO_OPS = gql`
  query listOPS($search: String, $companyId: String, $offset: Int) {
    listUsersPaginated(
      searchContains: $search
      companies_Contains: $companyId
      permission_In: ["mtl-api.can-validate-operations"]
      isNewraiUser: true
      isActive: true
    ) {
      results(limit: 10, offset: $offset) {
        id
        firstName
        lastName
        email
      }
    }
  }
`;
